"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const app_store_1 = __importDefault(require("./app-store"));
const files_1 = __importDefault(require("./files"));
const help_1 = __importDefault(require("./help"));
const medibank_oshc_1 = __importDefault(require("./medibank-oshc"));
const members_1 = __importDefault(require("./members"));
const oshc_1 = __importDefault(require("./oshc"));
const providers_1 = __importDefault(require("./providers"));
const sales_1 = __importDefault(require("./sales"));
const social_1 = __importDefault(require("./social"));
const third_party_1 = __importDefault(require("./third-party"));
module.exports = {
    APP_STORE: app_store_1.default,
    FILES: files_1.default,
    HELP: help_1.default,
    MEDIBANK_OSHC: medibank_oshc_1.default,
    MEMBERS: members_1.default,
    OSHC: oshc_1.default,
    PROVIDERS: providers_1.default,
    SALES: sales_1.default,
    SOCIAL: social_1.default,
    THIRD_PARTY: third_party_1.default,
};
